import "./App.css";
import React, { useState } from "react";
import Criteria from "./components/Criteria";
import Results from "./components/Results";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Instructions from "./components/Instructions";
import "./logo.png";
import Footer from "./components/Footer";
import Example from "./components/Example";

function App() {
	const [words, setWords] = useState([]);

	const findWords = (letters, pattern, size) => {
		if (letters.length < 3) {
			setWords([]);
			return;
		}

		size = parseInt(size);
		if (size > letters.length) {
			size = letters.length;
		} else if (size < 3) {
			size = 3;
		}

		let data = {
			letters: letters,
			pattern: pattern,
			length: size,
		};

		let url = "https://words.openlava.com/search";
		fetch(url, {
			method: "post",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((json) => setWords(json.data.words))
			.catch((error) => console.log(error));
	};

	return (
		<div className="App">
			<Header />
			<main className="wrapper">
				<Hero />
				<Instructions />
				<Criteria onSearch={findWords} />
				<Results words={words} />
				<Example />
				<Footer />
			</main>
		</div>
	);
}

export default App;
